// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1AEQc","text":"SelectPayment_text__1lg-E","title":"SelectPayment_title__7VHm7","btn":"SelectPayment_btn__o3Z_3"};